// recovery-repaginacao-02 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Cupom vale": "El cupón vale",
    "O que o nível %{n} dá": "Lo que da el nivel %{n}",
    "Unidade do requisito": "Unidad del requisito",
    "Valor em dinheiro": "Valor en dinero",
    "dias": "días",
    "obrigatório": "obligatorio",
};

export default catalogo;
